export default __webpack_public_path__ + "static/media/Otterbox.4a31788c.svg";